import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useMemo, useEffect } from 'react';
import classnames from 'classnames'; // $FlowFixMe: untyped import

import { CSSTransition } from 'react-transition-group';
import { Button } from "../../Controls";
import ThemeProvider from "../../../theme/ThemeProvider";
import useTheme from "../../../theme/useTheme";
import ClickOutside from '../ClickOutside';
import Portal from '../Portal';
import useKeyDown from '../../../hooks/useKeyDown';
import { setScrollLock } from '../../../utils/scrollUtils';
import styles from './Modal.scss';
export var composeSizes = function composeSizes(maxWidth, maxHeight) {
  var widthStyle = maxWidth ? {
    maxWidth: "".concat(maxWidth, "px")
  } : {
    width: 'fit-content'
  };
  var heightStyle = maxHeight ? {
    height: "".concat(maxHeight, "px")
  } : {};
  return _objectSpread({}, widthStyle, {}, heightStyle);
};

var Modal = function Modal(_ref) {
  var children = _ref.children,
      maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight,
      _ref$isOpened = _ref.isOpened,
      isOpened = _ref$isOpened === void 0 ? true : _ref$isOpened,
      isPadded = _ref.isPadded,
      _ref$noContainer = _ref.noContainer,
      noContainer = _ref$noContainer === void 0 ? false : _ref$noContainer,
      _ref$closeOnClickOuts = _ref.closeOnClickOutside,
      closeOnClickOutside = _ref$closeOnClickOuts === void 0 ? true : _ref$closeOnClickOuts,
      _ref$showCloseButton = _ref.showCloseButton,
      showCloseButton = _ref$showCloseButton === void 0 ? false : _ref$showCloseButton,
      className = _ref.className,
      onClose = _ref.onClose,
      onEnter = _ref.onEnter,
      onEntered = _ref.onEntered,
      onExit = _ref.onExit,
      onExited = _ref.onExited,
      header = _ref.header;

  var _useTheme = useTheme(),
      globalTheme = _useTheme.globalTheme;

  var contentWrapStyle = useMemo(function () {
    return composeSizes(maxWidth, maxHeight);
  }, [maxWidth, maxHeight]);
  useKeyDown('Escape', onClose);
  useEffect(function () {
    return setScrollLock(isOpened);
  }, [isOpened]);
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: globalTheme
  }, /*#__PURE__*/React.createElement(CSSTransition, {
    unmountOnExit: true,
    "in": isOpened,
    timeout: {
      enter: 250,
      exit: 250
    },
    classNames: {
      enter: styles.enter,
      enterActive: styles.enterActive,
      exitActive: styles.exitActive
    },
    onEnter: onEnter,
    onEntered: onEntered,
    onExit: onExit,
    onExited: onExited
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.modalWrap, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.overlay
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.body
  }, /*#__PURE__*/React.createElement(ClickOutside, {
    style: contentWrapStyle,
    className: classnames(styles.contentWrap),
    onClickOutside: closeOnClickOutside ? onClose : function () {}
  }, showCloseButton && /*#__PURE__*/React.createElement(Button, {
    icon: "close",
    onClick: onClose,
    styleType: "primary",
    className: styles.closeButton
  }), noContainer ? children : /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.content, _defineProperty({}, styles.isPadded, isPadded))
  }, header, children)))))));
};

export default Modal;